import find from "lodash/find";
import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";

import { PanelItem, PanelKey } from "./side_panel_store.types";
import { useSidePanelsStore } from "./use_side_panels_store";

export type UseSidePanelReturn<T extends object = any> = PanelItem<T> & { isOpen: boolean };

export const useSidePanel = <T extends object>(
  key: PanelKey,
  initialData: T = {} as T
): UseSidePanelReturn<T> => {
  const panelItem = useSidePanelsStore(useShallow((state) => find(state.panels, { key })));
  return useMemo(
    () => ({
      data: panelItem?.data ?? initialData,
      isOpen: !!panelItem,
      key: panelItem?.key ?? key,
      index: panelItem?.index ?? 0,
      isPersistent: panelItem?.isPersistent ?? false,
      isClosing: panelItem?.isClosing ?? false
    }),
    [panelItem, initialData, key]
  );
};
